import { Component, OnInit } from '@angular/core';
import Utils from 'src/app/utils';

declare var bootstrap: any;

@Component({
  selector: 'app-awards-demo',
  templateUrl: './awards-demo.component.html',
  styleUrls: ['./awards-demo.component.scss']
})
export class AwardsDemoComponent implements OnInit {

  page = "home";
  month="Sep 2020"

  constructor() { }

  ngOnInit(): void {

  }

  ngAfterViewInit()	: void {


    //[...(document.querySelectorAll('[data-bs-toggle="popover"]'))].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

    Utils.setupPopover();
  }

  

}
